function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_wVD1vEZStENsWbayvjsrdMkdDYWPoBek"
}, /*#__PURE__*/React.createElement("rect", {
  x: 244.161,
  y: 160,
  width: 45.839,
  height: 46.569
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: " M 268.356 168.663 L 268.356 173.799 L 255.623 166.898 L 268.356 160 L 268.356 165.207 C 279.096 165.748 287.974 172.961 289.701 182.549 C 291.428 192.136 285.539 201.518 275.542 205.105 C 265.546 208.691 254.132 205.518 248.102 197.474 C 242.071 189.431 243.046 178.683 250.446 171.633 C 251.181 170.984 252.353 170.977 253.098 171.615 C 253.844 172.254 253.896 173.311 253.217 174.008 C 247.065 179.87 246.242 188.803 251.236 195.503 C 256.231 202.203 265.705 204.876 274.035 201.935 C 282.365 198.994 287.32 191.227 285.957 183.244 C 284.595 175.262 277.28 169.202 268.356 168.663 Z ",
  fill: "#404040"
}));

var SvgReplayMeditationEdited = function SvgReplayMeditationEdited(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "244.161 160 45.839 46.569",
    width: "45.839pt",
    height: "46.569pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_wVD1vEZStENsWbayvjsrdMkdDYWPoBek)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _ref3)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplayMeditationEdited, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replay-meditation_edited.8fbe12d7.svg";
export { ForwardRef as ReactComponent };